import {
  Button,
  Card,
  Descriptions,
  Divider,
  message,
  Modal,
  Table,
  Tag,
  Tooltip,
  Select,
  Form,
  List,
  Image,
  Row,
  Col,
  DatePicker,
} from "antd"
import * as API from "common/api"
import * as COMMONS from "common/common"
import moment from "moment"
import "moment/locale/ja"
import React, { useEffect, useRef, useState } from "react"
import { Helmet } from "react-helmet-async"
import { FaEye } from "react-icons/fa"
import { useQuery } from "react-query"
import { useNavigate } from "react-router-dom"
import styled from "styled-components"

import useResizeObserver from "@react-hook/resize-observer"

moment.updateLocale("ja")

const CustomDatePicker = styled(DatePicker)`
  .ant-picker-input > input {
    text-align: center;
  }
`

const CustomTable = styled(Table)`
  .ant-table-selection-extra {
    position: initial;
    margin: 0;
    padding: 0;
  }

  .ant-table-ping-right,
  .ant-table-ping-left tr th.ant-table-cell {
    cursor: grab;
    cursor: -webkit-grab;
  }

  tr.active th.ant-table-cell {
    cursor: grabbing;
    cursor: -webkit-grabbing;
  }
`

const useSize = (target) => {
  const [size, setSize] = React.useState()

  React.useLayoutEffect(() => {
    setSize(target.current.getBoundingClientRect())
  }, [target])

  useResizeObserver(target, (entry) => setSize(entry.contentRect))
  return size
}

const { Option } = Select

const Purchases = (props) => {
  const navigate = useNavigate()

  const isMountedRef = COMMONS.USE_IS_MOUNTED_REF()
  const [purchaseFilterForm] = Form.useForm()

  const tableRef = useRef(null)
  const size = useSize(tableRef)
  const [isScrollableHintVisible, setIsScrollableHintVisible] = useState(false)

  const [purchases, setPurchases] = useState([])
  const [products, setProducts] = useState([])
  const [currentPurchase, setCurrentPurchase] = useState(undefined)
  const [isDetailModalVisible, setIsDetailModalVisible] = useState(false)

  const [paginationPerPage, setPaginationPerPage] = useState(20)
  const [paginationPage, setPaginationPage] = useState(1)
  const [paginationTotal, setPaginationTotal] = useState(0)
  const [paginationSort, setPaginationSort] = useState("desc")
  const [paginationSortKey, setPaginationSortKey] = useState(
    "transactionDateTime",
  )
  const [filterOrderDateFrom, setFilterOrderDateFrom] = useState(undefined)
  const [filterOrderDateTo, setFilterOrderDateTo] = useState(undefined)
  const [filterPurchaseStatus, setFilterPurchaseStatus] = useState(undefined)

  // useQuery([API.QUERY_KEY_ADMIN_POINT_SETTINGS], API.ADMIN_GET_POINT_SETTINGS, {
  //   onSuccess: (response) => {
  //     if (isMountedRef.current) {
  //       setPointSettings(response?.data || undefined)
  //     }
  //   },
  //   onError: (error) => {
  //     if (error?.response?.status === COMMONS.RESPONSE_PERMISSION_ERROR) {
  //       navigate(COMMONS.PERMISSION_ERROR_ROUTE)
  //     } else if (error?.response?.status === COMMONS.RESPONSE_SESSION_ERROR) {
  //       message.warning(COMMONS.ERROR_SESSION_MSG)
  //       navigate(COMMONS.ADMIN_LOGIN_ROUTE)
  //     } else if (error?.response?.status === COMMONS.RESPONSE_SYSTEM_ERROR) {
  //       message.error(COMMONS.ERROR_SYSTEM_MSG)
  //     } else {
  //       message.error(COMMONS.ERROR_SYSTEM_MSG)
  //     }
  //   },
  // })

  useQuery(
    [API.QUERY_KEY_ADMIN_PRODUCTS_LIST, {}],
    () => API.ADMIN_GET_PRODUCTS_LIST(),
    {
      onSuccess: (response) => {
        if (isMountedRef.current) {
          setProducts(response?.data || [])
        }
      },
      onError: (error) => {
        if (error?.response?.status === COMMONS.RESPONSE_PERMISSION_ERROR) {
          navigate(COMMONS.PERMISSION_ERROR_ROUTE)
        } else if (error?.response?.status === COMMONS.RESPONSE_SESSION_ERROR) {
          message.warning(COMMONS.ERROR_SESSION_MSG)
          navigate(COMMONS.ADMIN_LOGIN_ROUTE)
        } else if (error?.response?.status === COMMONS.RESPONSE_SYSTEM_ERROR) {
          message.error(COMMONS.ERROR_SYSTEM_MSG)
        } else {
          message.error(COMMONS.ERROR_SYSTEM_MSG)
        }
      },
    },
  )

  useQuery(
    [
      API.QUERY_KEY_ADMIN_PURCHASES,
      {
        paginationPerPage: paginationPerPage,
        paginationPage: paginationPage,
        paginationSort: paginationSort,
        paginationSortKey: paginationSortKey,
        filterOrderDateFrom: filterOrderDateFrom,
        filterOrderDateTo: filterOrderDateTo,
        filterPurchaseStatus: filterPurchaseStatus,
      },
    ],
    () =>
      API.ADMIN_GET_PURCHASES(
        paginationPerPage,
        paginationPage,
        paginationSort,
        paginationSortKey,
        filterOrderDateFrom,
        filterOrderDateTo,
        filterPurchaseStatus,
      ),
    {
      keepPreviousData: true,
      onSuccess: (response) => {
        if (isMountedRef.current) {
          if (response?.data?.rows && response?.data?.rows?.length > 0) {
            setPurchases(response.data.rows)
          } else {
            setPurchases([])
          }

          setPaginationPerPage(response.data.pp || 20)
          setPaginationPage(response.data.p || 1)
          setPaginationTotal(response?.data?.count || 0)
          setPaginationSort(response?.data?.sort || "desc")
          setPaginationSortKey(response?.data?.sortKey || "transactionDateTime")
        }
      },
      onError: (error) => {
        if (error?.response?.status === COMMONS.RESPONSE_PERMISSION_ERROR) {
          navigate(COMMONS.PERMISSION_ERROR_ROUTE)
        } else if (error?.response?.status === COMMONS.RESPONSE_SESSION_ERROR) {
          message.warning(COMMONS.ERROR_SESSION_MSG)
          navigate(COMMONS.ADMIN_LOGIN_ROUTE)
        } else if (error?.response?.status === COMMONS.RESPONSE_SYSTEM_ERROR) {
          message.error(COMMONS.ERROR_SYSTEM_MSG)
        } else {
          message.error(COMMONS.ERROR_SYSTEM_MSG)
        }
      },
    },
  )

  useEffect(() => {
    const slider = document.querySelector("thead.ant-table-thead tr")
    const body = document.querySelector(".ant-table-container .ant-table-body")
    let isDown = false
    let startX
    let scrollLeft

    slider.addEventListener("mousedown", (e) => {
      isDown = true
      slider.classList.add("active")
      startX = e.pageX - body.offsetLeft
      scrollLeft = body.scrollLeft
    })

    slider.addEventListener("mouseleave", () => {
      isDown = false
      slider.classList.remove("active")
    })

    slider.addEventListener("mouseup", () => {
      isDown = false
      slider.classList.remove("active")
    })

    slider.addEventListener("mousemove", (e) => {
      if (!isDown) {
        return
      }

      e.preventDefault()
      const x = e.pageX - body.offsetLeft
      const walk = (x - startX) * 3 //scroll-fast
      body.scrollLeft = scrollLeft - walk
    })
  }, [])

  useEffect(() => {
    if (
      tableRef?.current?.querySelector(".ant-table-ping-right") ||
      tableRef?.current?.querySelector(".ant-table-ping-left")
    ) {
      setIsScrollableHintVisible(true)
    } else {
      setIsScrollableHintVisible(false)
    }
  }, [size])

  const showDetailModal = (purchase) => {
    setCurrentPurchase(purchase)
    setIsDetailModalVisible(true)
  }

  const hideDetailModal = () => {
    setCurrentPurchase(undefined)
    setIsDetailModalVisible(false)
  }

  const shipmentColumns = [
    {
      key: "取引番号",
      title: <p className="whitespace-pre-wrap">{`取引\n番号`}</p>,
      dataIndex: "transactionHeadId",
      align: "center",
      width: 50,
    },
    {
      key: "オーダー番号",
      title: <p className="whitespace-pre-wrap">{`注文\n番号`}</p>,
      dataIndex: "terminalTranId",
      align: "center",
      width: 50,
    },

    // {
    //   key: "会員コード",
    //   title: <p className="whitespace-pre-wrap">{`会員\nコード`}</p>,
    //   dataIndex: "customerCode",
    //   align: "center",
    //   width: 100,
    // },
    {
      key: "氏名",
      title: "氏名",
      dataIndex: "fullName",
      align: "center",
      width: 120,
      render: (purchase) => (
        <>
          <p>
            {`${
              purchase?.User
                ? purchase.User.lastName
                : purchase?.Guest
                  ? purchase.Guest.lastName
                  : "ー"
            } ${
              purchase?.User
                ? purchase.User.firstName
                : purchase?.Guest
                  ? purchase.Guest.firstName
                  : "ー"
            }`}
          </p>
          <p className="text-xs text-gray-400">
            {`${
              purchase?.User
                ? purchase.User.lastNameKana
                : purchase?.Guest
                  ? purchase.Guest.lastNameKana
                  : "ー"
            } ${
              purchase?.User
                ? purchase.User.firstNameKana
                : purchase?.Guest
                  ? purchase.Guest.firstNameKana
                  : "ー"
            }`}
          </p>
        </>
      ),
    },
    // {
    //   key: "メールアドレス",
    //   title: <p className="whitespace-pre-wrap">{`メール\nアドレス`}</p>,
    //   dataIndex: "purchase",
    //   align: "center",
    //   width: 150,
    //   render: (purchase) => `${purchase?.email || "ー"}`,
    // },
    {
      key: "電話番号",
      title: "電話番号",
      dataIndex: "telephone",
      align: "center",
      width: 110,
      render: (purchase) =>
        `${
          purchase?.User
            ? purchase.User.telephone
            : purchase?.Guest
              ? purchase.Guest.telephone
              : "ー"
        } `,
    },
    {
      key: "配達住所",
      title: "配達住所",
      dataIndex: "address",
      align: "center",
      width: 150,
      render: (purchase) =>
        `〒
        ${
          purchase?.User
            ? purchase.User.zipPostal
              ? COMMONS.INSERT_CHARACTER(purchase.User.zipPostal, 3, "-")
              : "ー"
            : purchase?.Guest
              ? purchase.Guest.zipPostal
                ? COMMONS.INSERT_CHARACTER(purchase.Guest.zipPostal, 3, "-")
                : "ー"
              : "ー"
        }
         ${
           purchase?.User
             ? purchase?.User.address
             : purchase?.Guest
               ? purchase?.Guest.address
               : "ー"
         }`,
    },
    {
      key: "コメント",
      title: "コメント",
      dataIndex: "comment",
      align: "center",
      width: 100,
    },
    {
      key: "送料",
      title: "送料",
      dataIndex: "shippingFee",
      align: "center",
      width: 80,
      render: (Shipment) =>
        Shipment?.shippingFee
          ? `￥${Number(Shipment?.shippingFee).toLocaleString()}`
          : "ー",
    },
    {
      key: "合計",
      title: "合計",
      dataIndex: "total",
      align: "center",
      width: 80,
      render: (total) => (total ? `￥${Number(total).toLocaleString()}` : "ー"),
    },
    {
      key: "利用日",
      title: "利用日",
      dataIndex: "transactionDateTime",
      align: "center",
      width: 130,
      render: (transactionDateTime) =>
        transactionDateTime
          ? moment(transactionDateTime).format("YYYY年M月D日 HH:mm")
          : "ー",
    },
    {
      key: "決済方法",
      title: "決済方法",
      dataIndex: "paymentMethod",
      align: "center",
      width: 130,
      render: (PurchasePayment) =>
        PurchasePayment
          ? COMMONS.ORDER_PAYMENT_METHODS.find(
              (status) => status.value === PurchasePayment.payMode,
            )?.label
          : "ー",
    },
    {
      key: "購入状況",
      title: "購入状況",
      dataIndex: "purchaseStatus",
      align: "center",
      width: 150,
      render: (Purchase) =>
        Purchase?.purchaseStatus === COMMONS.PURCHASE_STATUS_INCOMPLETE_VALUE
          ? Purchase?.PurchasePayment?.payMode ===
              COMMONS.ORDER_PAYMENT_METHOD_CONVENIENCE_STORE &&
            !Purchase?.PurchasePayment?.storeNo
            ? COMMONS.PURCHASE_STATUS_LINK_GENERATE.find(
                (status) => status.value === Purchase?.purchaseStatus,
              )?.label
            : Purchase?.PurchasePayment?.payMode ===
                  COMMONS.ORDER_PAYMENT_METHOD_CREDIT_CARD &&
                Purchase?.PurchasePayment?.status ===
                  COMMONS.PURCHASE_STATUS_INCOMPLETE_VALUE
              ? COMMONS.PURCHASE_STATUS_LINK_GENERATE.find(
                  (status) => status.value === Purchase?.purchaseStatus,
                )?.label
              : COMMONS.PURCHASE_STATUS.find(
                  (status) => status.value === Purchase?.purchaseStatus,
                )?.label
          : COMMONS.PURCHASE_STATUS_CANCELED_VALUE
            ? Purchase?.expiredAt
              ? COMMONS.PURCHASE_STATUS_EXPIRED.find(
                  (status) => status.value === Purchase?.purchaseStatus,
                )?.label
              : COMMONS.PURCHASE_STATUS.find(
                  (status) => status.value === Purchase?.purchaseStatus,
                )?.label
            : "ー",
    },
    {
      key: "action",
      title: "",
      dataIndex: "action",
      align: "center",
      width: 50,
      render: (purchase) => (
        <>
          <Tooltip title="詳細" placement="left">
            <Button
              className="m-1"
              icon={<FaEye className="inline-block anticon" />}
              onClick={() => showDetailModal(purchase)}
            />
          </Tooltip>
        </>
      ),
    },
  ]

  const handleTableChange = (paginationData, filters, sorter) => {
    if (paginationData.pageSize !== paginationPerPage) {
      setPaginationPerPage(paginationData.pageSize)
    }

    if (paginationData.current !== paginationPage) {
      setPaginationPage(paginationData.current)
    }

    if (sorter && sorter.order) {
      if (sorter.order === "ascend") {
        if (sorter.order !== paginationSort) {
          setPaginationSort("asc")
        }
      } else if (sorter.order === "descend") {
        if (sorter.order !== paginationSort) {
          setPaginationSort("desc")
        }
      }
    }

    if (sorter && sorter.field) {
      if (sorter.field !== paginationSortKey) {
        setPaginationSortKey(sorter.field)
      }
    }
  }

  const handleFilter = (data) => {
    if (data.filterOrderDateFrom !== filterOrderDateFrom) {
      setFilterOrderDateFrom(data.filterOrderDateFrom)
    }
    if (data.filterOrderDateTo !== filterOrderDateTo) {
      setFilterOrderDateTo(data.filterOrderDateTo)
    }
    if (data.filterPurchaseStatus !== filterPurchaseStatus) {
      setFilterPurchaseStatus(data.filterPurchaseStatus)
    }
  }

  return (
    <>
      <Helmet>
        <title>配達一覧 | {process.env.REACT_APP_SYSTEM_NAME}</title>
      </Helmet>
      <Card
        title="処理中・期限切れ一覧"
        className="animate__animated animate__fadeIn"
        bordered={false}
      >
        <Row>
          <Col xs={24}>
            <Form
              form={purchaseFilterForm}
              onFinish={handleFilter}
              size="large"
              initialValues={{
                filterOrderDateFrom: undefined,
                filterOrderDateTo: undefined,
                filterPurchaseStatus: undefined,
              }}
            >
              <Row gutter={[16, 16]} justify="start">
                <Col
                  xs={{ span: 24 }}
                  md={{ span: 12 }}
                  lg={{ span: 6 }}
                  xl={{ span: 6 }}
                >
                  <Form.Item
                    help="利用日から"
                    name="filterOrderDateFrom"
                    className="mb-4"
                  >
                    <CustomDatePicker className="w-full" inputReadOnly />
                  </Form.Item>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  md={{ span: 12 }}
                  lg={{ span: 6 }}
                  xl={{ span: 6 }}
                >
                  <Form.Item
                    help="利用日まで"
                    name="filterOrderDateTo"
                    className="mb-4 w-full"
                  >
                    <CustomDatePicker className="w-full" inputReadOnly />
                  </Form.Item>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  md={{ span: 12 }}
                  lg={{ span: 6 }}
                  xl={{ span: 6 }}
                >
                  <Form.Item
                    help="購入状況"
                    name="filterPurchaseStatus"
                    className="mb-4"
                  >
                    <Select placeholder="購入状況を選択してください" allowClear>
                      {COMMONS.PURCHASE_STATUS_QUERY.map((ss) => (
                        <Option
                          key={ss.value}
                          className={ss.class}
                          value={ss.value}
                        >
                          {ss.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[8, 8]} justify="left mt-4">
                <Col className="text-xs" xs={16}>
                  <p>
                    ・リンク発行中：GMO決済ページが表示され、決済未完了の状態。在庫を取置き中。（当日0：00になっても決済完了しない場合は取消し＆在庫戻す）。
                  </p>
                  <p>
                    ・決済中…コンビニ払いなど、申込完了したが未払いの状態。在庫を取置き中。
                  </p>
                  <p>
                    ・期限切れ…途中離脱して日付を跨いだ、決済用ページを無視した、コンビニ支払いの期限切れ等。取置き在庫は戻しています。
                  </p>
                </Col>
              </Row>
              <Row gutter={[8, 8]} justify="center mt-4">
                <Col>
                  <Button type="primary" htmlType="submit" className="px-12">
                    検索
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
        <Divider />

        <Tooltip
          visible={isScrollableHintVisible}
          placement="topRight"
          title="⇦スクロールできます⇨"
          overlayStyle={{
            zIndex: 999,
          }}
        >
          <CustomTable
            ref={tableRef}
            bordered
            size="small"
            columns={shipmentColumns}
            locale={{ emptyText: "配達がありません" }}
            onChange={handleTableChange}
            scroll={{
              x: 640,
              y: 720,
            }}
            pagination={{
              responsive: true,
              showSizeChanger: true,
              onShowSizeChange: (current, pageSize) =>
                setPaginationPerPage(pageSize),
              current: paginationPage,
              pageSize: paginationPerPage,
              total: paginationTotal,
              showTotal: (total, range) =>
                `全${total}件中${range[0]}～${range[1]}件目`,
              defaultCurrent: 1,
              defaultPageSize: 20,
              position: ["bottomRight"],
            }}
            dataSource={
              purchases
                ? purchases.map((purchase) => {
                    return {
                      key: purchase?.transactionHeadId,
                      transactionHeadId: purchase?.transactionHeadId || "ー",
                      terminalTranId: purchase?.terminalTranId || "ー",
                      fullName: purchase,
                      telephone: purchase,
                      address: purchase,
                      comment: purchase?.comment || "ー",
                      shippingFee: purchase?.Shipment,
                      total: purchase?.total || "ー",
                      transactionDateTime: purchase?.transactionDateTime,
                      paymentMethod: purchase?.PurchasePayment,
                      purchaseStatus: purchase,
                      action: purchase,
                    }
                  })
                : []
            }
          />
        </Tooltip>
      </Card>
      <Modal
        title="配達詳細"
        visible={isDetailModalVisible}
        onCancel={hideDetailModal}
        footer={null}
        destroyOnClose
        centered
        width={720}
        bodyStyle={{ maxHeight: "90vh", overflow: "auto" }}
      >
        <Descriptions
          bordered
          layout="vertical"
          title="注文情報"
          column={4}
          className="mb-4"
        >
          <Descriptions.Item label="取引番号">
            {currentPurchase?.transactionHeadId
              ? "＃" + currentPurchase?.transactionHeadId
              : "ー"}
          </Descriptions.Item>
          <Descriptions.Item label="注文番号">
            {currentPurchase?.terminalTranId
              ? "  ＃" + currentPurchase?.terminalTranId
              : "ー"}
          </Descriptions.Item>

          <Descriptions.Item label="小計">
            {`￥${
              currentPurchase?.subTotal
                ? Number(
                    COMMONS.getHistoryOrderSubtotal({
                      subTotal: currentPurchase.subTotal,
                      totalTax: currentPurchase?.totalTax,
                      sellDivision: currentPurchase?.sellDivision,
                    }),
                  ).toLocaleString()
                : 0
            }`}
          </Descriptions.Item>
          <Descriptions.Item label="送料">
            {`￥${
              currentPurchase?.Shipment?.shippingFee
                ? Number(currentPurchase.Shipment.shippingFee).toLocaleString()
                : 0
            }`}
          </Descriptions.Item>
          {/* <Descriptions.Item label="利用ポイント">
            {currentPurchase?.pointsSpent
              ? `-￥${COMMONS.CONVERT_POINT_TO_CURRENCY({
                  pointSettings,
                  points: currentPurchase.pointsSpent,
                }).toLocaleString()}（${Number(
                  currentPurchase.pointsSpent
                ).toLocaleString()}P）`
              : `￥${0}（${0}P）`}
          </Descriptions.Item> */}
          <Descriptions.Item label="合計" className="font-bold">
            {`￥${
              currentPurchase?.total
                ? Number(currentPurchase.total).toLocaleString()
                : 0
            }`}
          </Descriptions.Item>
          <Descriptions.Item label="注文日" span={2}>
            {currentPurchase?.transactionDateTime
              ? moment(currentPurchase.transactionDateTime).format(
                  "YYYY年M月D日 HH:mm",
                )
              : "ー"}
          </Descriptions.Item>
          <Descriptions.Item label="キャンセル日" span={1}>
            {currentPurchase?.cancelDateTime
              ? moment(currentPurchase.cancelDateTime).format(
                  "YYYY年M月D日 HH:mm",
                )
              : "ー"}
          </Descriptions.Item>
          {/* <Descriptions.Item label="配達時間" span={1}>
            {COMMONS.DELIVERY_TIMES.find(
              (time) => time.id === currentPurchase?.Shipment?.deliveryTime,
            )?.start || "ー"}
            {COMMONS.DELIVERY_TIMES.find(
              (time) => time.id === currentPurchase?.Shipment?.deliveryTime,
            )?.end
              ? "～" +
                COMMONS.DELIVERY_TIMES.find(
                  (time) => time.id === currentPurchase?.Shipment?.deliveryTime,
                )?.end
              : ""}
          </Descriptions.Item> */}
          <Descriptions.Item label="購入状況" span={4}>
            {currentPurchase?.purchaseStatus ? (
              <Tag
                color={
                  COMMONS.PURCHASE_STATUS.find(
                    (status) =>
                      status.value === currentPurchase?.purchaseStatus,
                  )?.color || ""
                }
              >
                {currentPurchase?.purchaseStatus ===
                COMMONS.PURCHASE_STATUS_INCOMPLETE_VALUE
                  ? currentPurchase?.PurchasePayment?.payMode ===
                      COMMONS.ORDER_PAYMENT_METHOD_CONVENIENCE_STORE &&
                    !currentPurchase?.PurchasePayment?.storeNo
                    ? COMMONS.PURCHASE_STATUS_LINK_GENERATE.find(
                        (status) =>
                          status.value === currentPurchase?.purchaseStatus,
                      )?.label
                    : currentPurchase?.PurchasePayment?.payMode ===
                          COMMONS.ORDER_PAYMENT_METHOD_CREDIT_CARD &&
                        currentPurchase?.PurchasePayment?.status ===
                          COMMONS.PURCHASE_STATUS_INCOMPLETE_VALUE
                      ? COMMONS.PURCHASE_STATUS_LINK_GENERATE.find(
                          (status) =>
                            status.value === currentPurchase?.purchaseStatus,
                        )?.label
                      : COMMONS.PURCHASE_STATUS.find(
                          (status) =>
                            status.value === currentPurchase?.purchaseStatus,
                        )?.label
                  : COMMONS.PURCHASE_STATUS_CANCELED_VALUE
                    ? currentPurchase?.expiredAt
                      ? COMMONS.PURCHASE_STATUS_EXPIRED.find(
                          (status) =>
                            status.value === currentPurchase?.purchaseStatus,
                        )?.label
                      : COMMONS.PURCHASE_STATUS.find(
                          (status) =>
                            status.value === currentPurchase?.purchaseStatus,
                        )?.label
                    : "ー"}
              </Tag>
            ) : (
              "ー"
            )}
          </Descriptions.Item>
        </Descriptions>
        <Divider />
        <Descriptions title="お届け先情報" bordered column={1} className="mb-4">
          <Descriptions.Item label="氏名">
            {`${
              currentPurchase?.Shipment
                ? currentPurchase?.Shipment.lastName
                : "ー"
            } ${
              currentPurchase?.Shipment
                ? currentPurchase?.Shipment.firstName
                : "ー"
            }`}
          </Descriptions.Item>
          <Descriptions.Item label="電話番号">
            {currentPurchase?.Shipment
              ? currentPurchase?.Shipment.telephone
              : "ー"}
          </Descriptions.Item>
          <Descriptions.Item label="配達住所">
            {`〒${
              currentPurchase?.Shipment?.zipPostal
                ? COMMONS.INSERT_CHARACTER(
                    currentPurchase.Shipment.zipPostal,
                    3,
                    "-",
                  )
                : ""
            } ${currentPurchase?.Shipment?.address1 || ""}${
              currentPurchase?.Shipment?.address2 || ""
            }${currentPurchase?.Shipment?.address3 || ""}`}
          </Descriptions.Item>
        </Descriptions>
        <Descriptions title="お客様情報" bordered column={1}>
          <Descriptions.Item label="会員コード">
            {currentPurchase?.customerCode || "ー"}
          </Descriptions.Item>
          <Descriptions.Item label="氏名">
            {`${currentPurchase?.Shipment?.lastName || "ー"} ${
              currentPurchase?.Shipment?.firstName || "ー"
            }`}
          </Descriptions.Item>
          <Descriptions.Item label="氏名（カナ）">
            {`${currentPurchase?.Shipment?.lastNameKana || "ー"} ${
              currentPurchase?.Shipment?.firstNameKana || "ー"
            }`}
          </Descriptions.Item>

          <Descriptions.Item label="電話番号">
            {currentPurchase?.Shipment?.telephone || "ー"}
          </Descriptions.Item>
          <Descriptions.Item label="配達住所">
            {`〒${
              currentPurchase?.Shipment?.zipPostal
                ? COMMONS.INSERT_CHARACTER(
                    currentPurchase.Shipment.zipPostal,
                    3,
                    "-",
                  )
                : ""
            } ${currentPurchase?.Shipment?.address1 || ""}${
              currentPurchase?.Shipment?.address2 || ""
            }${currentPurchase?.Shipment?.address3 || ""}`}
          </Descriptions.Item>
        </Descriptions>
        <Divider />
        <List
          bordered
          dataSource={
            currentPurchase?.purchaseDetails &&
            currentPurchase?.purchaseDetails.length > 0
              ? currentPurchase?.purchaseDetails
              : []
          }
          renderItem={(product) => (
            <List.Item>
              <List.Item.Meta
                avatar={
                  <Image
                    src={
                      products.find(
                        (p) => p?.productCode === product?.productCode,
                      )?.productImages[0]?.picUrl
                        ? `${API.UPLOADS_URL}${
                            products.find(
                              (p) => p?.productCode === product?.productCode,
                            )?.productImages[0]?.picUrl
                          }`
                        : "/default.jpg"
                    }
                    className="rounded object-contain"
                    preview={{
                      mask: <FaEye />,
                      src: products.find(
                        (p) => p?.productCode === product?.productCode,
                      )?.productImages[0]?.picUrl
                        ? `${API.UPLOADS_URL}${
                            products.find(
                              (p) => p?.productCode === product?.productCode,
                            )?.productImages[0]?.picUrl
                          }`
                        : "/default.jpg",
                      maskClassName: "rounded",
                    }}
                    fallback="/default.jpg"
                    width={100}
                    height={50}
                  />
                }
                title={<p>{product?.productCode || ""}</p>}
                description={
                  <>
                    <p className="font-bold">
                      {`${
                        products.find(
                          (p) => p?.productCode === product?.productCode,
                        )?.productName || ""
                      }（${
                        product?.grind === null && product?.roast === null
                          ? `数量：${product?.quantity}`
                          : `${(
                              Number(product?.quantity || 0) * 100
                            ).toLocaleString()}g・${product?.roast || "ー"}・${
                              product?.grind || "ー"
                            }`
                      }）`}
                    </p>
                    <p>
                      {`￥${Number(
                        COMMONS.getHistoryProductTotal({
                          price: product?.price,
                          quantity: 1,
                          taxDivision: product?.taxDivision,
                          sellDivision: currentPurchase?.sellDivision,
                          taxRate: currentPurchase?.taxRate,
                          taxRounding: currentPurchase?.taxRounding,
                        }),
                      ).toLocaleString()} ${
                        product?.grind === null && product?.roast === null
                          ? ""
                          : "(100g)"
                      } × ${product?.quantity || 0}点 ＝ `}
                      <span className="font-bold">{`￥${COMMONS.getHistoryProductTotal(
                        {
                          price: product?.price,
                          quantity: product?.quantity,
                          taxDivision: product?.taxDivision,
                          sellDivision: currentPurchase?.sellDivision,
                          taxRate: currentPurchase?.taxRate,
                          taxRounding: currentPurchase?.taxRounding,
                        },
                      ).toLocaleString()}`}</span>
                    </p>
                  </>
                }
              />
            </List.Item>
          )}
        />
      </Modal>
    </>
  )
}

export default Purchases
